import React from 'react';
import injectSheet, { ThemeProvider } from 'react-jss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Subscribe } from 'unstated';
import {
  Card, CardText, CardBody, CardTitle, CardImg,
} from 'reactstrap';
import JamParentSelectContainer from '../containers/JamParentSelectContainer';

const styles = {
  cardContainer: {
    marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 'rgb(187, 187, 187) -2px 0px 8px',
    },
  },
  card: {
    minWidth: '16.25rem',
    maxWidth: '16.25rem',
    minHeight: '22.88rem',
    maxHeight: '22.88rem',
    borderRadius: '0.3125rem',
  },
  title: {
    marginBottom: '0.2rem',
    fontSize: '0.9rem',
    fontFamily: 'Lato, Arial',
    color: '#1F1F1F',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  titleName: {
    fontFamily: 'Lato',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.3125rem',
    // TODO: this only works on Chrome
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    // END TODO
  },
  description: {
    fontFamily: 'Lato',
    fontSize: '0.875rem',
    color: '#656565',
    lineHeight: '1.3125rem',
    // TODO: this only works on Chrome
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    // END TODO
  },
  cardIconWrapper: {
    fontSize: '8rem',
    width: '8rem',
    height: '8rem',
    margin: '0px auto 1rem',
  },
  cardBody: {
    marginTop: '1rem',
  },
  isCardSelected: {
    border: '0.1rem solid #34A5DA',
  },
  selectedBtnWrapper: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
  selectedBtn: {
    backgroundColor: '#34A5DA',
    color: '#FFFFFF',
    fontFamily: 'Lato',
    fontSize: '0.875rem',
    borderTopLeftRadius: '10px',
    lineHeight: '28px',
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  cardImageWrapper: {
    height: '9rem',
  },
  image: {
    height: '100%',
    width: '100%',
  },
};

function onClickJamCard(props, jamParent) {
  return function(event) {
    const { getRandomCard, random, type, randomCardIndex } = props;
    if (random) {
      return jamParent.handleClickCard(Object.assign({random: true, step: props.step, type: type, randomCardIndex: randomCardIndex},getRandomCard()))(event);
    } 
    return jamParent.handleClickCard(props)(event);
  };
}

const JamCard = (props) => {
  const {
    classes, random, title, blurb, icon, type, image,
  } = props;

  const topicTitle = random ? 'Random Topic:' : `${type} Title:`;
  const topicName = random ? `Selecting this will randomly select a ${title}` : title;
  return (
    <Subscribe to={[JamParentSelectContainer]}>
      { jamParent => (
        <div className={classes.cardContainer} onClick={onClickJamCard(props, jamParent)}>
          <Card className={classNames(classes.card, {
            [classes.isCardSelected]: jamParent.isCardSelected(props),
          })}
          >
            <div className={!image ? classes.cardIconWrapper : classes.cardImageWrapper}>
              {!image ? <i className={icon} />
                : <CardImg top className={classes.image} src={image} alt="Card image cap" />
              }
            </div>
            <CardBody className={classes.cardBody}>
              <CardTitle className={classes.title}>
                { topicTitle }
              </CardTitle>
              <CardText className={classes.titleName}>
                { topicName }
              </CardText>
              { !random
                ? (
                  <div className={classes.descriptionWrapper}>
                    <CardTitle className={classes.title}>
                      {`${type} Blurb:`}
                    </CardTitle>
                    <p className={classes.description}>
                      { blurb }
                    </p>
                  </div>
                )
                : ''}
            </CardBody>
            {jamParent.isCardSelected(props)
              ? (
                <div className={classes.selectedBtnWrapper}>
                  <div className={classes.selectedBtn}>Selected</div>
                </div>
              ) : ''}
          </Card>
        </div>
      )}
    </Subscribe>
  );
};

JamCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(JamCard);



// WEBPACK FOOTER //
// ./src/components/JamCard.js